import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SportWrapper } from './styles';
import CompetitionTable from '../../../HubLive/SportTable/CompetitionTable';
import ConfigManager from '../../../../common/configManager/configManager';

class SportTableWrapper extends Component {
  componentDidMount() {
    const interval = ConfigManager.getSportRefreshInterval(this.props.sportId) ? ConfigManager.getSportRefreshInterval(this.props.sportId) : 60000;
    if (this.props.date === 'today') {
      this.sportTimer = setInterval(this.updateTableData, interval);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.date === 'today') {
      if (!this.sportTimer) {
        const interval = ConfigManager.getSportRefreshInterval(this.props.sportId) ? ConfigManager.getSportRefreshInterval(this.props.sportId) : 60000;
        this.sportTimer = setInterval(this.updateTableData, interval);
      }
    }
  }
  componentWillUnmount() {
    if (this.sportTimer) {
      clearInterval(this.sportTimer);
    }
  }
  updateTableData = () => {
    this.props.actions.getToday(this.props.date, this.props.sportId);
  };
  render() {
    const {
      competitions,
      actions,
      dictionary,
      isMobile,
      date,
      sportId,
      isDeskFav,
    } = this.props;
    return (
      <SportWrapper>
        {competitions && competitions.size > 0 && competitions.map((competition, index) => {
          if (competition) {
            if (sportId === '6C' || sportId === '6M') {
              return (
                <CompetitionTable
                  actions={actions}
                  competition={competition}
                  key={index}
                  dictionary={dictionary}
                  date={date}
                  sportId={sportId}
                  isMobile={isMobile}
                  showRowScorer
                  isDeskFav={isDeskFav}
                  isRace
                />
              );
            } else {
              return (
                <CompetitionTable
                  actions={actions}
                  competition={competition}
                  key={index}
                  dictionary={dictionary}
                  date={date}
                  sportId={sportId}
                  isMobile={isMobile}
                  showRowScorer
                  isDeskFav={isDeskFav}
                />
              );
            }
          }
          return <div />;
        })
        }
      </SportWrapper>
    );
  }
}

SportTableWrapper.propTypes = {
  competitions: PropTypes.any,
  actions: PropTypes.any,
  isMobile: PropTypes.bool,
  dictionary: PropTypes.any,
  date: PropTypes.any,
  sportId: PropTypes.any,
  isDeskFav: PropTypes.bool,
};

export default SportTableWrapper;

